// extracted by mini-css-extract-plugin
module.exports = {"svg--small":"svg-sprite_svg--small__tHSdg","svgSprite":"svg-sprite_svgSprite__iCzt4","svg--fill":"svg-sprite_svg--fill__eUdKT"};